export const errorActions = {
    UPDATE_INSTALLATION_SETTINGS: 'update-installation-settings',
    UPDATE_XERO_SUBSCRIPTION: 'update-xero-subscription',
};
